import React from 'react';

function TransitionsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#FFF" fillRule="nonzero" transform="translate(-564 -2143)">
          <g transform="translate(531 1975)">
            <g transform="translate(33 168)">
              <g transform="translate(.5)">
                <path d="M9.49 14.51c.672.673.681 1.76.02 2.444L2.976 23.49A1.743 1.743 0 01.51 21.025l6.536-6.536a1.743 1.743 0 012.444.021zM11.089.17a1.556 1.556 0 011.64.141l3.625 2.704 4.13-1.48a1.556 1.556 0 011.976 1.977l-1.456 4.286 2.68 3.47c.36.472.417 1.11.147 1.639-.277.52-.818.847-1.408.85l-4.526-.055-2.476 3.63a1.556 1.556 0 01-2.767-.437l-1.34-4.322-4.208-1.226a1.556 1.556 0 01-.44-2.766l3.7-2.618-.127-4.384a1.556 1.556 0 01.85-1.41z" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default TransitionsIcon;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/Transitions.js